var render = function render(){var _vm=this,_c=_vm._self._c;return _c('sign-page',{attrs:{"title-text":"采购物品","request":_vm.request,"table-size":"small","column-list":_vm.columnList,"form-parms-add":_vm.formParmsAdd,"deal-form-data":_vm.dealFormData,"form-parms-update":_vm.formParmsUpdate,"table-actions-fixed":true,"tableActionsWidth":100,"need-data-file":true},on:{"dataUpdate":_vm.dataUpdate}})
}
var staticRenderFns = []

export { render, staticRenderFns }